import React from 'react';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import IconButton from '@mui/material/IconButton';
import classnames from 'classnames';
import PropTypes from 'prop-types';

function AddRemoveControl({
  className = '',
  disabled = false,
  onAdd = () => {},
  onRemove = () => {},
  showAdd = false,
  showRemove = false,
}) {
  return (
    <div
      className={classnames(className, 'box-content flex w-16')}
      data-theme="v2"
    >
      {showRemove && (
        <IconButton disabled={disabled} type="button" onClick={onRemove}>
          <RemoveCircleOutlineIcon
            className={classnames({
              'text-text-secondary': !disabled,
              'text-grey-600': disabled,
            })}
          />
        </IconButton>
      )}
      {showAdd && (
        <IconButton
          className="ml-auto"
          disabled={disabled}
          type="button"
          onClick={onAdd}
        >
          <AddCircleOutlineIcon
            className={classnames({
              'text-text-secondary': !disabled,
              'text-grey-600': disabled,
            })}
          />
        </IconButton>
      )}
    </div>
  );
}

AddRemoveControl.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  showAdd: PropTypes.bool,
  showRemove: PropTypes.bool,
};

export default AddRemoveControl;
